  <template>
  <div id="page-wrap">
    <PageHeader></PageHeader>
    <main>
      <section class="transactions section-margin">
        <div class="container-fluid">
          <div class="row row-spacing-btm">
            <div class="col-xl-8 offset-xl-2 col-xs-12">
              <div class="page-heading">
                <div class="row">
                  <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                    <h1>Transactions</h1>
                  </div>
                  <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
                    <div class="row">
                      <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                        <div class="input-group input-daterange">
                          <div class="date-from col-md-5 clearfix">
                            <div class="row" @click="resetTxn">
                              <DatePicker
                                placeholder="YYYY-MM-DD"
                                @dp-change="filterTxns"
                                v-model="query.startDate"
                                :config="config"
                              ></DatePicker>
                              <span class="caret"></span>
                            </div>
                          </div>
                          <div class="input-group-addon col-md-2">TO</div>
                          <div class="date-to col-md-5 clearfix">
                            <div class="row" @click="resetTxn">
                              <DatePicker
                                placeholder="YYYY-MM-DD"
                                @dp-change="filterTxns"
                                v-model="query.endDate"
                                :config="config"
                              ></DatePicker>
                              <span class="caret"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center">
                        <a
                          href="javascript:void(0)"
                          @click="toggleSearch"
                          :class="{'open': searchIsOpen}"
                          class="togglesearch"
                        >
                          <span class="ic-search"></span>
                          <span class="ic-cross"></span>
                        </a>
                      </div>
                      <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                        <!-- :href="encodeURI(`data:text/csv;charset=utf-8, ${csv}`)" -->
                        <a
                          href="javascript:void(0)"
                          @click="downloadCSV"
                          v-b-modal.downloadModal
                          class="btn btn-download"
                          download="TransactionData.csv"
                        >
                          <i class="ic-download btn btn-danger"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="widget brder-t-r-0">
                <!-- transaction table start -->
                <table v-if="transactions" id="transaction-data" class="table highlight-tr">
                  <thead>
                    <th hidden class="tbl-chkbox">
                      <div class="chkbox-holder">
                        <input type="checkbox" id="checkbox-11" class="regular-checkbox">
                        <label for="checkbox-11"></label>
                      </div>
                    </th>
                    <th>EPL Order ID</th>
                    <th>Marketplace Order ID</th>
                    <th style="min-width:100px;">Date</th>
                    <th>Amount</th>
                    <th>Settlement Status</th>
                    <th>Action</th>
                  </thead>
                  <tbody>
                    <template v-if="transactions.length > 0">
                      <tr
                        class="txn-row"
                        :class="{'active': txn.id == activeTxn.id}"
                        v-for="(txn, index) in transactions"
                        :key="index"
                      >
                        <td hidden class="tbl-chkbox">
                          <div class="chkbox-holder">
                            <input type="checkbox" id="checkbox-12" class="regular-checkbox">
                            <label for="checkbox-12"></label>
                          </div>
                        </td>
                        <td class="order-id">
                          <a href="javascript:void(0)" @click.stop="setTxn(txn,true)">{{txn.id}}</a>
                        </td>
                        <td>{{txn.marketplaceOrderId}}</td>
                        <td class="col-date">
                          {{txn.txnDateStr | formatDate}}
                          <small>{{txn.txnDateStr | formatTime}}</small>
                        </td>
                        <td>{{txn.txnAmount | formatCurrency}}</td>
                        <td>
                          <span
                            class="alert"
                            :class="[{ 'alert-success':((txn.status.toUpperCase() == 'SETTLEMENT_FINAL') || (txn.status.toUpperCase() == 'SETTLED'))  },
                                                           { 'alert-warning':((txn.status.toUpperCase() != 'SETTLEMENT_FINAL') && (txn.status.toUpperCase() != 'SETTLED'))  }]"
                          >{{((txn.status.toUpperCase() == 'SETTLEMENT_FINAL') || (txn.status.toUpperCase() == 'SETTLED')) ? "True" : "False"}}</span>
                        </td>
                        <td class="text-left">
                          <TxnStatusUpdateDD
                            :toggleConfirmationBox="toggleConfirmationBox.bind(this)"
                            :getStatusUpdateConfirmation="getStatusUpdateConfirmation.bind(this)"
                            :calledIn="'txn'"
                            :resetTxn="resetTxn.bind(this)"
                            :getCurrentTxnStatus="getCurrentTxnStatus.bind(this)"
                            :setCurrentTxnStatus="setCurrentTxnStatus.bind(this)"
                            :setTxn="setTxn.bind(this)"
                            :getTxnUpdateForm="getTxnUpdateForm.bind(this)"
                            :setTxnUpdateForm="setTxnUpdateForm.bind(this)"
                            :txnStatusEnum="txnStatusEnum"
                            :txn="txn"
                            :showCancel="showCancel"
                          ></TxnStatusUpdateDD>
                          <TransactionDetail
                            v-if="activeTxn&&txn.id == activeTxn.id"
                            :toggleConfirmationBox="toggleConfirmationBox.bind(this)"
                            :getStatusUpdateConfirmation="getStatusUpdateConfirmation.bind(this)"
                            :resetTxn="resetTxn.bind(this)"
                            :getCurrentTxnStatus="getCurrentTxnStatus.bind(this)"
                            :setCurrentTxnStatus="setCurrentTxnStatus.bind(this)"
                            :setTxn="setTxn.bind(this)"
                            :getTxnUpdateForm="getTxnUpdateForm.bind(this)"
                            :setTxnUpdateForm="setTxnUpdateForm.bind(this)"
                            :txnStatusEnum="txnStatusEnum"
                            :activeTxn="txn"
                            :showCancel="showCancel"
                          ></TransactionDetail>
                        </td>
                      </tr>
                    </template>
                    <tr v-if="transactions.length == 0">
                      <td colspan="6">
                        <p class="text-center noTxnsMessage">No Transactions Available.</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="paginationWrapper">
                  <paginate
                    v-if="transactions && Math.ceil(totalTxnCount / query.limit) > 1"
                    :page-count="Math.ceil(totalTxnCount / query.limit)"
                    :page-range="7"
                    :margin-pages="1"
                    :click-handler="navigateToPage"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-link-class="'page-link'"
                    :next-link-class="'page-link'"
                  ></paginate>
                </div>

                <!-- transaction table end -->

                <!-- search form start -->
                <form @submit.prevent="filterTxns" @reset="resetForm">
                  <div class="search-wrapper">
                    <div class="row form-row">
                      <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                        <label>Merchant Order ID</label>
                      </div>
                      <div class="col-lg-9 col-md-9 col-sm-9 col-xs-12">
                        <input
                          type="text"
                          class="form-input"
                          oninvalid="this.setCustomValidity('Please enter comma seperated alpha-numerical ids.')"
                          v-model="marketplaceOrderIdCSV"
                          pattern="[a-zA-Z0-9-{0,1}]+(,\s?[a-zA-Z0-9-{0,1}]+)*"
                          @keyup="marketplaceOrderIdToArray"
                          onchange="try{setCustomValidity('')}catch(e){}"
                          placeholder="Enter multiple ids separated by comma"
                        >
                        <small
                          class="text-danger"
                          v-if="exceededLengthOnMarketPlaceOrderId"
                        >Only 0 - 50 entries are allowed</small>
                      </div>
                    </div>
                    <div class="row form-row">
                      <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                        <label>ePL Order ID</label>
                      </div>
                      <div class="col-lg-9 col-md-9 col-sm-9 col-xs-12">
                        <input
                          type="text"
                          class="form-input"
                          v-model="txnIdCSV"
                          oninvalid="this.setCustomValidity('Please enter comma seperated numerical ids.')"
                          pattern="[0-9]+(,\s?[0-9]+)*"
                          @keyup="txnIdToArray"
                          placeholder="Enter multiple ids separated by comma"
                          onchange="try{setCustomValidity('')}catch(e){}"
                        >
                        <small
                          class="text-danger"
                          v-if="exceededLengthOnTxnId"
                        >Only 0 - 50 entries are allowed</small>
                      </div>
                    </div>

                    <div class="row form-row">
                      <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                        <label>Transaction Status</label>
                      </div>
                      <div class="col-lg-9 col-md-9 col-sm-9 col-xs-12">
                        <ul class="floated-li clearfix">
                          <li v-if="status.searchParameter" v-for="(status, key) in txnStatusEnum">
                            <div class="chkbox-holder">
                              <input
                                type="checkbox"
                                :id="'checkbox-search-'+key"
                                :checked="query.status"
                                name="status"
                                :value="key"
                                v-model="query.status"
                                class="regular-checkbox"
                              >
                              <label :for="'checkbox-search-'+key"></label>
                            </div>
                            <label
                              class="checkbox-label"
                              :for="'checkbox-search-'+key"
                            >{{status.name | removeUnderscores}}</label>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <!-- TODO: Implement Setlement status filter -->
                    <!-- <div class="row form-row">
                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                          <label>Settlement Status</label>
                        </div>
                        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-12">
                          <ul class="floated-li clearfix">
                            <li>
                              <div class="chkbox-holder">
                                <input type="checkbox" id="checkbox-9" class="regular-checkbox" checked />
                                <label for="checkbox-9"></label>Settled
                              </div>
                            </li>
                            <li>
                              <div class="chkbox-holder">
                                <input type="checkbox" id="checkbox-10" class="regular-checkbox" checked />
                                <label for="checkbox-10"></label>Pending
                              </div>
                            </li>
                          </ul>
                        </div>
                    </div>-->
                    <div class="row form-row">
                      <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                        <label>UTR Number</label>
                      </div>
                      <div class="col-lg-9 col-md-9 col-sm-9 col-xs-12">
                        <input type="text" v-model="query.utrNumber" class="form-input half-width">
                      </div>
                    </div>
                    <div class="row form-row mb-0">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                        <input type="reset" value="Reset" class="btn btn-form btn-danger">
                        <input type="submit" value="Search" class="btn btn-form btn-primary">
                      </div>
                    </div>
                  </div>
                </form>
                <!-- search form end -->
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <!-- <DownloadModal v-if="transactions" :transactions="transactions"></DownloadModal> -->
    <!-- <modal v-if="showModal">
      <div class="popup-content">
        <button type="button" class="close" id="closepopup" @click="closeModal()">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 40 40"
            width="30"
            height="30"
            xml:space="preserve"
          >
            <path
              class="st0"
              fill="#000"
              d="M8.7,7.6c-0.4-0.4-1-0.4-1.4,0C6.9,8,6.9,8.6,7.3,9l11,11l-11,11c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0 l11-11l11,11c0.4,0.4,1,0.4,1.4,0c0.4-0.4,0.4-1,0-1.4l-11-11L32,9c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0l-11,11L8.7,7.6z"
            ></path>
          </svg>
        </button>
        <span>
          <a
            :href="encodeURI(`data:text/csv;charset=utf-8, ${csv}`)"
            v-b-modal.downloadModal
            class="btn btn-download"
            download="TransactionData.csv"
          >
            <i class="ic-download btn btn-danger"></i>
          </a>
        </span>
      </div>
    </modal>-->
    <modal v-if="showModal" @closeModal="showModal=false">
      <div slot="body">
        <div>
          <p>Download is restricted to 1000 records, please ensure you apply proper filters before downloading the report.</p>
          <div class="action-row">
            <button class="btn btn-cancel" @click="showModal=false">Cancel</button>
            <a
              :href="encodeURI(`data:text/csv;charset=utf-8, ${csv}`)"
              v-b-modal.downloadModal
              class="btn btn-download--modified"
              download="TransactionData.csv"
              @click="showModal=false"
            >Download</a>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

  <script>
import PageHeader from "./PageHeader";
import DownloadModal from "./DownloadModal";
import DatePicker from "vue-bootstrap-datetimepicker";
import TransactionDetail from "./TransactionDetail";
import TxnStatusUpdateDD from "./TxnStatusUpdateDD";
import Modal from "./Modal";
// Import date picker css
import "eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css";
import Paginate from "vuejs-paginate";

import { mapGetters } from "vuex";
export default {
  name: "Transactions",
  filters: {
    removeUnderscores: function(value) {
      if (!value) return "";
      return value.replace(/_/g, " ");
    }
  },
  data() {
    return {
      statusUpdateConfirmation: {
        status: false,
        txnStatusToBeUpdated: undefined,
        message: "Are you sure you want to update the transaction status to"
      },
      currentTxnStatus: {
        txn: undefined,
        status: undefined,
        refundAmt: undefined
      },
      showTxnUpdateForm: false,
      txnStatusEnum: {
        updated: {
          name: "Updated",
          searchParameter: false
        },
        agreed: {
          name: "Customer Agreed",
          searchParameter: false
        },
        confirmed: {
          name: "Confirmed",
          searchParameter: true
        },
        confirmed_update: {
          name: "Confirmed Update",
          searchParameter: false
        },
        shipped: {
          name: "Shipped",
          searchParameter: false
        },
        returned: {
          name: "Returned",
          searchParameter: true
        },
        return_initiated: {
          name: "Return Initiated",
          searchParameter: false
        },
        partially_returned: {
          name: "Partial Return",
          searchParameter: true
        },
        refunded: {
          name: "Refunded",
          searchParameter: true
        },
        partial_refunded: {
          name: "Partial Refund",
          searchParameter: true
        },
        refund_pending: {
          name: "Refund Pending",
          searchParameter: true
        },
        partial_refund_pending: {
          name: "Partial Refund Pending",
          searchParameter: true
        },
        cancelled: {
          name: "Cancelled",
          searchParameter: true
        },
        delivered: {
          name: "Delivered",
          searchParameter: true
        },
        settled: {
          name: "Settled",
          searchParameter: true
        },
        partially_settled: {
          name: "Delivered",
          searchParameter: false
        },
        settled_final: {
          name: "Settled Final",
          searchParameter: false
        },
        // 'settled_other':{
        //   name:'Settled Other',
        //   searchParameter:true
        // },
        deconstructed: {
          name: "Deconstructed",
          searchParameter: true
        },
        deconstruction_failed: {
          name: "Deconstruction Failed",
          searchParameter: false
        },
        showCancel: false
      },
      activeTxn: {},
      error: undefined,
      searchIsOpen: false,
      fromDate: undefined, //new Date(new Date().getTime() - 3 * 24 * 60 * 60 * 1000),
      toDate: undefined, //new Date(),
      config: {
        format: "YYYY-MM-DD",
        useCurrent: false
      },
      pageNumber: 1,
      txnIdCSV: undefined,
      marketplaceOrderIdCSV: undefined,
      exceededLengthOnTxnId: false,
      exceededLengthOnMarketPlaceOrderId: false,
      query: {
        txnId: [],
        marketplaceOrderId: [],
        startDate: new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000),
        endDate: new Date(),
        status: [],
        offset: 0,
        limit: 10,
        utrNumber: undefined
      },
      showModal: false
    };
  },
  methods: {
    getCurrentTxnStatus(key) {
      if (key) {
        return this.currentTxnStatus[key];
      }
      return this.currentTxnStatus;
    },

    setCurrentTxnStatus(val) {
      return (this.currentTxnStatus = val);
    },

    resetForm() {
      this.query.txnId = [];
      this.query.marketplaceOrderId = [];
      this.query.status = [];
      this.query.offset = 0;
      this.query.limit = 10;
      this.query.utrNumber = undefined;
      this.query.startDate = undefined;
      this.query.endDate = undefined;
      this.txnIdCSV = undefined;
      this.marketplaceOrderIdCSV = undefined;
    },
    resetTxn() {
      this.activeTxn = {};
      this.setTxnUpdateForm(false);
      this.statusUpdateConfirmation.status = false;
    },
    setTxn(txn, showCancel = false) {
      this.activeTxn = txn;
      this.showCancel = showCancel;
    },
    getTxnUpdateForm() {
      return this.showTxnUpdateForm;
    },
    setTxnUpdateForm(val) {
      this.showTxnUpdateForm = val;
    },
    toggleConfirmationBox(state, txnStatusToBeUpdated) {
      this.statusUpdateConfirmation.status = state;
      this.statusUpdateConfirmation.txnStatusToBeUpdated = txnStatusToBeUpdated;
      return this.statusUpdateConfirmation.status;
    },
    getStatusUpdateConfirmation() {
      return this.statusUpdateConfirmation;
    },
    txnIdToArray() {
      if (this.txnIdCSV) {
        var valArray = this.txnIdCSV.split(",");
        for (var key in valArray) {
          valArray[key] = parseInt(valArray[key]);
        }
        this.query.txnId = valArray;
      } else {
        this.query.txnId = [];
      }
    },

    marketplaceOrderIdToArray() {
      if (this.marketplaceOrderIdCSV) {
        var valArray = this.marketplaceOrderIdCSV.split(",");
        for (var key in valArray) {
          valArray[key] = valArray[key].toString().trim();
        }
        this.query.marketplaceOrderId = valArray;
      } else {
        this.query.marketplaceOrderId = [];
      }
    },

    navigateToPage(page) {
      this.pageNumber = page;
      this.filterTxns();
    },

    filterTxns() {
      var query = {};
      if (this.query.txnId.length) {
        query.txnId = this.query.txnId;
      } else {
        delete query.txnId;
      }
      if (this.query.status.length) {
        query.status = this.query.status;
      } else {
        delete query.status;
      }
      if (this.query.marketplaceOrderId.length) {
        query.marketplaceOrderId = this.query.marketplaceOrderId;
      } else {
        delete query.marketplaceOrderId;
      }
      query.startDate = this.query.startDate;
      query.endDate = this.query.endDate;
      query.offset = this.query.limit * (this.pageNumber - 1);
      query.limit = this.query.limit;
      query.utrNumber = this.query.utrNumber;

      //Allow only 50 entris in CSV
      if (this.query.txnId.length > 50) {
        this.exceededLengthOnTxnId = true;
      } else {
        this.exceededLengthOnTxnId = false;
      }
      if (this.query.marketplaceOrderId.length > 50) {
        this.exceededLengthOnMarketPlaceOrderId = true;
      } else {
        this.exceededLengthOnMarketPlaceOrderId = false;
      }
      if (
        this.exceededLengthOnTxnId ||
        this.exceededLengthOnMarketPlaceOrderId
      ) {
        return;
      }
      if (query.status && query.status[0] === "delivered") {
        query.status.push("partially_settled");
      }
      this.$store
        .dispatch("transactions", {
          sessionId: this.sessionId,
          query
        })
        .then(() => {
          if (this.searchIsOpen) {
            this.searchIsOpen = !this.searchIsOpen;
            $(".search-wrapper").slideToggle();
          }
        })
        .catch(err => {
          if (err.status != 401) {
            this.error = err.data;
          } else {
            this.$router.push({ name: "Login" });
          }
        });
    },

    toggleSearch() {
      this.searchIsOpen = !this.searchIsOpen;
      $(".search-wrapper").slideToggle();
      this.resetTxn();
    },
    downloadCSV() {
      const query = JSON.parse(JSON.stringify(this.query));
      query.limit = 1000;
      this.$store
        .dispatch("allTransactions", {
          sessionId: this.sessionId,
          query
        })
        .then(() => this.$store.dispatch("JSONtoCSV", this.allTransactions))
        .then(() => (this.showModal = true));
    }
  },
  computed: {
    ...mapGetters([
      "transactions",
      "totalTxnCount",
      "sessionId",
      "csv",
      "user",
      "allTransactions"
    ])
  },
  mounted() {
    this.filterTxns();
  },
  components: {
    PageHeader,
    DatePicker,
    Paginate,
    DownloadModal,
    TransactionDetail,
    TxnStatusUpdateDD,
    Modal
  }
};
</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
@import "../assets/scss/custom.scss";
small {
  color: #aeaeae;
}
.noTxnsMessage {
  width: 100%;
  font-size: 14px;
  text-align: center;
  margin: 20px 0;
}
.search-wrapper {
  position: absolute;
  width: 97%;
  height: 710px;
  background: $colorwhite;
  left: 0;
  right: 0;
  margin: 0 auto;
  top: rem(100px);
  z-index: 1;
  display: none;
  padding: rem(30px);
  @include border-radius(rem(0), rem(0), rem(8px), rem(8px));
  .form-input {
    border: none;
    border-bottom: solid rem(1px) $bordercolor;
    width: 100%;
    outline: none;
    @include input-placeholder {
      text-align: right;
      color: $labelcolor;
    }
  }
  label {
    color: $labelcolor;
    font-size: rem(16px);
    font-weight: 400;
  }
  .form-row {
    margin-bottom: rem(40px);
  }
  ul.floated-li {
    li {
      width: 30%;
      margin-bottom: rem(15px);
    }

    .regular-checkbox + label {
      margin-right: rem(8px);
    }
  }
  .btn {
    max-width: 250px;
    margin: 0 1rem;
  }
}

.togglesearch {
  span.ic-cross {
    @extend .hideme;
  }
  &.open {
    span.ic-cross {
      display: inline-block;
    }

    span.ic-search {
      @extend .hideme;
    }
  }
}

.txn-row {
  &.active {
    background: #fffde7;
  }
}

.paginationWrapper {
  position: absolute;
  bottom: 50px;
}
.widget {
  min-height: 600px;
  padding-bottom: 150px;
}

.btn-download {
  padding: 0;
  background: transparent;
  border: 0;
  &:active,
  &:focus {
    box-shadow: none;
    outline: none;
  }
  .btn-danger {
    padding: 0;
    border-radius: 100%;
    border: 0;
    &:active,
    &:focus {
      box-shadow: none;
      outline: none;
    }
  }
}
#transaction-data {
  tr {
    td {
      &.order-id {
        font-weight: 600;
        color: $darktextcolor;
      }
    }
  }
}

.user-trans-details {
  background: $colorwhite;
  width: rem(275px);
  height: auto;
  position: absolute;
  @include border-radius(rem(8px), rem(8px), rem(8px), rem(8px));
  z-index: 3;
  box-shadow: 0 0 rem(13px) rgba(0, 0, 0, 0.04);
  @include transform(translateY(-35%));
  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);
  right: rem(-65px);
  padding: rem(20px);
  h5 {
    color: $darktextcolor;
    font-size: rem(16px);
  }
  p {
    font-size: rem(12px);
    color: $basetextcolor;
  }
  h5,
  p {
    margin-bottom: rem(2px);
  }
  .user-details {
    position: relative;
    margin-bottom: rem(25px);
    .name-initials {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  h2 {
    font-size: rem(24px);
    position: relative;
    color: $darktextcolor;
  }
  .trans-details {
    position: relative;
    h2 {
      padding-top: rem(22px);
      margin-bottom: rem(30px);
      &:before {
        content: "Total";
        position: absolute;
        color: $labelcolor;
        font-size: rem(14px);
        top: 0;
        left: 0;
      }
      a {
        color: $primaryColor;
        font-size: rem(12px);
        margin-left: rem(10px);
      }
    }
    .transaction-breakup {
      margin-bottom: rem(30px);
      ul {
        li {
          margin-bottom: rem(5px);
          font-size: rem(12px);
          &.late-charges {
            color: $dangercolor;
          }
          span {
            float: right;
            font-size: rem(14px);
            margin-top: rem(-5px);
          }
        }
      }
    }
  }
  .settlement-date {
    p {
      color: $basetextcolor;
      font-size: rem(14px);
    }
  }
  .dropdown-toggle {
    background: #eff4ff;
    width: 100%;
    color: #718099;
  }
}

.name-initials {
  background: rgba(244, 92, 95, 0.05);
  color: $dangercolor;
  width: rem(40px);
  height: rem(40px);
  display: inline-block;
  text-align: center;
  line-height: rem(40px);
  border-radius: 100%;
  font-size: rem(14px);
}

.paginationWrapper {
  margin: 20px auto 0;
}
.btn-download--modified {
  border: 1px solid transparent;
  padding: 0.5rem 2.5rem;
  background: #377cfd;
  transition: all 0.3s;
  width: max-content;
  color: #fff;
  &:hover {
    background: #fc805c;
  }
}
.action-row {
  display: flex;
  justify-content: center;
}
.btn-cancel {
  background: #fff;
  border: 1px solid;
  margin-right: 2rem;
  padding: 0.5rem 1.5rem;
}
.btn-download--modified,
.btn-cancel {
  display: block;
  margin-top: 2rem;
  border-radius: 2rem;
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Transactions.vue